import { render, staticRenderFns } from "./status-fake-processing.component.vue?vue&type=template&id=d23a1a50"
import script from "./status-fake-processing.component.ts?vue&type=script&lang=ts&external"
export * from "./status-fake-processing.component.ts?vue&type=script&lang=ts&external"
import style0 from "./status-fake-processing.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports